import styled from 'styled-components';

export const LoyaltyLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  & div:first-child {
    height: fit-content;
  }
`;
